import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { UploadsConfigModel } from '../models/upload/uploadsconfig.model';
import { catchError, filter, map } from 'rxjs/operators';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

export type UploadExcelProgressEvent =
  | { type: 'progress'; progress: number; uploadComplete: boolean }
  | { type: 'complete'; body: any };

@Injectable({
  providedIn: 'root'
})

export class UploadsConfigService {
  public uploadsConfigModel = new UploadsConfigModel();
  myUploadsSet = new Set<string>();
  private host = environment.apiUrl + "uploadsconfig/uploadtemplate";
  public loggedinUser: string = '';
  opts = [];
  optsEmpEmp = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
  }

  public getTemplatesList(): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/gettemplateslist`);
  }

  public getRecordTemplatesList(): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/getrecordtemplateslist`);
  }

  public getRecordsList(recordname: string): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/getrecordslist` + '/' + recordname);
  }

  public getRecordsListForAction(recordname: string, actionType: string): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(
      `${this.host}/getrecordslist/${encodeURIComponent(recordname)}/${encodeURIComponent(actionType || 'Insert')}`
    );
  }

  public getColumnsList(recordName: string): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/getcolumnslist` + '/' + recordName);
  }

  public getColumnsConfigList(recordName: string,name: string): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/getcolumnsconfiglist` + '/' + recordName+ '/' + name);
  }

  public getColumnsEditList(recordName: string): Observable<UploadsConfigModel[]> {
    return this.http.get<UploadsConfigModel[]>(`${this.host}/getcolumnseditlist` + '/' + recordName);
  }

  public getSqlQueryForAction(recordTemplate: string, actionType: string): Observable<{ sqlquery: string }> {
    return this.http.get<{ sqlquery: string }>(
      `${this.host}/getsqlqueryforaction/${encodeURIComponent(recordTemplate)}/${encodeURIComponent(actionType)}`
    );
  }
  public saveTemplate(uploadsModel: UploadsConfigModel[]): Observable<UploadsConfigModel[]> {
    return this.http.post<UploadsConfigModel[]>(`${this.host}/addtemplate`, uploadsModel);
  }

  public updateUploadsConfig(uploadsModel: UploadsConfigModel[]): Observable<UploadsConfigModel[]> {
    return this.http.post<UploadsConfigModel[]>(`${this.host}/updatetemplate`, uploadsModel);
  }

  public uploadExcel(excelData: any, recordtemplate: string, actionType: string = 'Insert'): Observable<any> {
    return this.http.post(
      `${this.host}/uploadExcelData/${encodeURIComponent(recordtemplate)}/${encodeURIComponent(actionType)}`,
      excelData
    );
  }

  public uploadExcelWithProgress(
    excelData: any,
    recordtemplate: string,
    actionType: string = 'Insert'
  ): Observable<UploadExcelProgressEvent> {
    return this.http.post(
      `${this.host}/uploadExcelData/${encodeURIComponent(recordtemplate)}/${encodeURIComponent(actionType)}`,
      excelData,
      {
        reportProgress: true,
        observe: 'events'
      }
    ).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          const uploadComplete = !!event.total && event.loaded >= event.total;
          const progress = event.total
            ? Math.round((event.loaded / event.total) * 100)
            : Math.min(85, Math.round(event.loaded / 5000));
          return { type: 'progress' as const, progress, uploadComplete };
        }
        if (event.type === HttpEventType.Response) {
          return { type: 'complete' as const, body: event.body };
        }
        return null;
      }),
      filter((event): event is UploadExcelProgressEvent => event !== null)
    );
  }

  // public uploadExcelNew1(formData: FormData): Observable<CustomHttpRespone> {
  //   return this.http.post<CustomHttpRespone>(`${this.host}/uploadExcelDataNew`+'/',formData);
  // }

  uploadExcel1(file: File,recordtemplate:string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${this.host}/uploadExcelDataNew`+'/'+recordtemplate, formData);
  }

 

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


